// AboutPage component - Converted from pages/about.vue
// Uses shared section components instead of a simple placeholder block
import React from 'react';
import HeaderOne from '../components/HeaderOne';
import VideoOne from '../components/VideoOne';
import ProductOne from '../components/ProductOne';
import CallToActionOne from '../components/CallToActionOne';
import Footer from '../components/Footer';
import AboutTwo from '../../components/AboutTwo.jsx';
import PageHeader from '../../components/PageHeader.jsx';

const AboutPage: React.FC = () => {
  
  React.useEffect(() => {
  }, []);

  return (
    <>
      <HeaderOne />
      <PageHeader title="À propos" />
      {/* Reusing home sections for About until dedicated about sections are ported */}
      <AboutTwo />
      <CallToActionOne />
      <ProductOne />
      <VideoOne />
     
      
    
      <Footer />
    </>
  );
};

export default AboutPage;
